export const THEMES = {
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    emoji: '🌙',
    bg: 'radial-gradient(ellipse 90% 70% at 25% 15%, #1e1040 0%, #0d0b1e 50%, #060610 100%)',
    focusAccent: '#a78bfa',
    breakAccent: '#38bdf8',
    longBreakAccent: '#34d399',
    cardBg: 'rgba(255,255,255,0.04)',
    cardBorder: 'rgba(255,255,255,0.08)',
    inputBg: 'rgba(255,255,255,0.06)',
    orbs: ['rgba(139,92,246,0.2)', 'rgba(6,182,212,0.12)', 'rgba(52,211,153,0.07)'],
    orbPositions: ['10% 20%', '75% 65%', '55% 90%'],
    textPrimary: '#f1f0ff',
    textMuted: 'rgba(225,220,255,0.45)',
    textDim: 'rgba(225,220,255,0.25)',
  },
  aurora: {
    id: 'aurora',
    name: 'Aurora',
    emoji: '🌌',
    bg: 'radial-gradient(ellipse 90% 70% at 60% 0%, #0c3050 0%, #0a1828 50%, #040c16 100%)',
    focusAccent: '#2dd4bf',
    breakAccent: '#a78bfa',
    longBreakAccent: '#fb923c',
    cardBg: 'rgba(255,255,255,0.035)',
    cardBorder: 'rgba(45,212,191,0.12)',
    inputBg: 'rgba(45,212,191,0.06)',
    orbs: ['rgba(45,212,191,0.18)', 'rgba(167,139,250,0.12)', 'rgba(251,146,60,0.07)'],
    orbPositions: ['70% 10%', '15% 60%', '80% 85%'],
    textPrimary: '#f0fdf9',
    textMuted: 'rgba(167,243,208,0.45)',
    textDim: 'rgba(167,243,208,0.25)',
  },
  warmGlow: {
    id: 'warmGlow',
    name: 'Warm Glow',
    emoji: '🕯️',
    bg: 'radial-gradient(ellipse 90% 70% at 20% 40%, #2d1200 0%, #160900 50%, #080400 100%)',
    focusAccent: '#fb923c',
    breakAccent: '#fbbf24',
    longBreakAccent: '#f472b6',
    cardBg: 'rgba(255,255,255,0.035)',
    cardBorder: 'rgba(251,146,60,0.12)',
    inputBg: 'rgba(251,146,60,0.07)',
    orbs: ['rgba(251,146,60,0.22)', 'rgba(251,191,36,0.14)', 'rgba(244,114,182,0.07)'],
    orbPositions: ['20% 30%', '70% 70%', '45% 85%'],
    textPrimary: '#fff7ed',
    textMuted: 'rgba(254,215,170,0.5)',
    textDim: 'rgba(254,215,170,0.28)',
  },
  deepFocus: {
    id: 'deepFocus',
    name: 'Deep Focus',
    emoji: '⚫',
    bg: 'linear-gradient(180deg, #0c0c12 0%, #070710 100%)',
    focusAccent: '#e2e8f0',
    breakAccent: '#94a3b8',
    longBreakAccent: '#64748b',
    cardBg: 'rgba(255,255,255,0.025)',
    cardBorder: 'rgba(255,255,255,0.06)',
    inputBg: 'rgba(255,255,255,0.04)',
    orbs: ['rgba(226,232,240,0.07)', 'rgba(148,163,184,0.04)', 'rgba(100,116,139,0.03)'],
    orbPositions: ['30% 20%', '70% 60%', '50% 90%'],
    textPrimary: '#e2e8f0',
    textMuted: 'rgba(226,232,240,0.42)',
    textDim: 'rgba(226,232,240,0.22)',
  },
  rainGlass: {
    id: 'rainGlass',
    name: 'Rain Glass',
    emoji: '🌧️',
    bg: 'radial-gradient(ellipse 90% 70% at 15% 75%, #051228 0%, #07192c 50%, #020b18 100%)',
    focusAccent: '#38bdf8',
    breakAccent: '#818cf8',
    longBreakAccent: '#4ade80',
    cardBg: 'rgba(56,189,248,0.04)',
    cardBorder: 'rgba(56,189,248,0.1)',
    inputBg: 'rgba(56,189,248,0.06)',
    orbs: ['rgba(56,189,248,0.14)', 'rgba(129,140,248,0.1)', 'rgba(74,222,128,0.06)'],
    orbPositions: ['15% 70%', '80% 20%', '55% 50%'],
    textPrimary: '#f0f9ff',
    textMuted: 'rgba(186,230,253,0.48)',
    textDim: 'rgba(186,230,253,0.25)',
  },
};

export const getTheme = (id) => THEMES[id] || THEMES.midnight;

export const getModeAccent = (theme, mode) => {
  if (mode === 'focus') return theme.focusAccent;
  if (mode === 'short_break') return theme.breakAccent;
  return theme.longBreakAccent;
};

export const THEME_LIST = Object.values(THEMES);
